<template>
  <Card class="mb-4">

    <b-row>
      <b-col md="6" v-if="!offer.is_company">
        <h4>Vorname</h4>
        <base-input
          prepend-icon="fas fa-calendar"
          v-model="offer.firstname"
          type="text"
          name="Vorname"
          placeholder="Vorname"
        >
        </base-input>
      </b-col>

      <b-col md="6" v-if="!offer.is_company">
        <h4>Nachname</h4>
        <base-input
          prepend-icon="fas fa-calendar"
          v-model="offer.lastname"
          type="text"
          name="Nachname"
          placeholder="Nachname"
        >
        </base-input>
      </b-col>

      <b-col md="6" v-if="offer.is_company">
        <h4>Firmenname</h4>
        <base-input
          prepend-icon="fas fa-calendar"
          v-model="offer.company_name"
          type="text"
          name="Firmenname"
          placeholder="Firmenname"
        >
        </base-input>
      </b-col>
    </b-row>


    <template #header>
      <h2 class="mb-0">Stammdaten</h2>
    </template>
    <div>
      
      <b-row>

      <b-col md="6" v-if="!offer.is_company">
        <h4>Geburtsdatum</h4>
        <!-- csc-date-input v-model="offer.dob"/ -->
        <base-input
          prepend-icon="fas fa-calendar"
          v-model="offer.dob"
          type="date"
          name="Geburtsdatum"
          rules="required"
          placeholder="DD.MM.YYYY"
        >
        </base-input>
      </b-col>

        <b-col md="6">
            <h4>Führerscheindatum</h4>
            <base-input prepend-icon="fas fa-calendar"
              v-model="offer.softfair_fuehrerscheindatum" type="date"
              name="Führerscheindatum" rules="required"
              placeholder="DD.MM.YYYY"></base-input>
          </b-col>
    </b-row>

      
      <div>
        <div>
          <b-row>
            <b-col lg="6">
              <h4>Anschrift</h4>
            </b-col>
          </b-row>

          <b-row>
            
            <b-col lg="6">
              <BaseInput v-model="offer.softfair_ort" label="Ort" />
            </b-col>
            <b-col lg="6">
              <BaseInput v-model="offer.softfair_postleitzahl" label="Postleitzahl" />
            </b-col>
          </b-row>
          

          <b-row>
            <b-col lg="6">
              <h4 @click="toggleAnschriftDetails()">Details</h4>
            </b-col>
            <b-col lg="6" class="text-right">
              <i v-if="show_anschrift_details" class="fa fa-chevron-down" @click="toggleAnschriftDetails()"></i>
              <i v-else class="fa fa-chevron-left" @click="toggleAnschriftDetails()"></i>
            </b-col>
          </b-row>


          <div v-if="show_anschrift_details">

<b-row>
  <b-col lg="6">
    <BaseInput v-model="offer.address.street" label="Strasse" />
  </b-col>
  <b-col lg="6">
    <BaseInput v-model="offer.address.number" label="Nummer" />
  </b-col>
</b-row>

</div>

        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BaseInput from '@/components/Inputs/BaseInput.vue';
import CscDateInput from '@/components/Inputs/CscDateInput.vue';
import Card from '@/components/Cards/Card.vue';

function calculateAge(birthdate) {
  if (!birthdate) return 0;
  const today = new Date();
  const birthDate = new Date(birthdate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export default {
  name: "softfair-stammdaten",

  components: {
    BaseInput,
    CscDateInput,
    Card,
  },
  data() {
    return {
      loading: false,
      show_anschrift_details: false,
    };
  },
  methods: {
    toggleAnschriftDetails() {
      this.show_anschrift_details = !this.show_anschrift_details;
    },
    setDefaults() {
    },
    financial(x) {
      if (isNaN(Number.parseFloat(x).toFixed(2))) {
        return 0;
      }
      return Number.parseFloat(x).toFixed(2);
    },
  },
  computed: {
    ...mapGetters({
      currentAccount: "currentAccount",
    }),
    ...mapState({
      account: state => state.account,
      offer: (state) => state.softfairOffer,
    }),
  },
  mounted() {
  },
};
</script>
<style></style>